import { Calendar, Badge, List } from "rsuite"
import { useState, useRef, useEffect } from "react"
import { BadgeDollarSign, ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from "react-router-dom";

const CalendarWidget = (props) => {

    // filter out completed projects
    const projects = props.projects.filter(project => project.status !== "Complete")
    // console.log(projects)

    function getDueDates(date) {
        let due = []
        if (!date) {
          return [];
        }
        // const day = date.getDate();
      for (let i = 0; i < projects.length; i++) {
        const project = projects[i];
        const dueDate = new Date(project.due_date);

        if (dueDate.toDateString() === date.toDateString()) {
          due.push({ due_date: dueDate.toDateString(), start_date:project.start_date, client: project.client ,title: project.title, project_id: project.project_id, fee: project.fee, paid: project.paid, status: project.status });
        }
      }
      return due;
    }

    function renderCell(date) {
      const list = getDueDates(date);
    
      if (list.length) {
        return <Badge className="calendar-todo-item-badge" color={"yellow"}/>;
      }
    
      return null;
    }

    const [selectedDate, setSelectedDate] = useState();

    const handleSelect = date => {
      setSelectedDate(date);
      console.log(date)
      // update Month selection depending on date selected
      if (date.getMonth() !== month) {
        selectMonth(date.getMonth());
        selectYear(date.getFullYear());
      }
    };

    const TodoList = ({ date }) => {
      const list = getDueDates(date);
      console.log("Days due list: ", list)

      if (!list.length) {
        return null;
      }

      return (
        <List style={{ flex: 1 }} className="calendar-todo-list">
        <div className="date-list-header">{date.toLocaleDateString('en-US')}</div>
        <div className="date-list">
        {list.map(item => (
          <Link to="project" state={{ project_id: item.project_id }} key={item.project_id} className="blobLink">
          {/* <Link to="project" state={{ project: item }} key={item.project_id} className="blobLink">  */}
            <div className="list-item" key={item.title} index={item.title}>
              {/* <div>{date.toDateString()}</div> */}
              <div>{item.client}</div>
              <div>{item.title}</div>
            </div>
            </Link>
          ))}
        </div>

        </List>
      );
    };

    //income
    let today = new Date();
    let thisMonth = today.getMonth();
    let thisYear = today.getFullYear();
    let thisDay = today.getDate();

    const monthlyTarget = 2000;
    const [month, selectMonth] = useState(thisMonth);
    const [year, selectYear] = useState(thisYear);   
    const [monthIncome, setMonthIncome] = useState(0);
    const [monthPaid, setMonthPaid] = useState(0);

        useEffect(() => {
            let tempMonthIncome = 0;
            let tempMonthPaid = 0;
            for (let i = 0; i < props.projects.length; i++) {
                const project = props.projects[i];
                const dueDate = new Date(project.due_date);
                const dueMonth = dueDate.getMonth();
                const dueYear = dueDate.getFullYear();
                const amount = project.amount;
                const client = project.client;
                const title = project.title;
                const income = Number(project.fee.replace(/[^0-9.-]+/g,""));
                const paid = Number(project.paid.replace(/[^0-9.-]+/g,""));
        
                if (dueMonth === month && dueYear === year) {
                    tempMonthIncome += income;
                    tempMonthPaid += paid;
                    // console.log("This month: " + dueMonth);
                    // console.log("Project: " + title);
                    // console.log("Client: " + client);
                    // console.log("Amount: " + amount);
                } else {
                    // console.log("Not this month: " + dueMonth);
                }
                setMonthIncome(tempMonthIncome);
                setMonthPaid(tempMonthPaid);
            }
        }, [month, props.projects]);
    
        const updateMonth  = (dir) => {
            if (dir === "next") {
                if (month === 11) {
                    selectMonth(0);
                    selectYear(year + 1);
                } else {
                    selectMonth(month + 1);
                }
            } else if (dir === "prev") {
                if (month === 0) {
                    selectMonth(11);
                    selectYear(year - 1);
                } else {
                    selectMonth(month - 1);
                }
            }
            setSelectedDate(new Date(year, month, thisDay));
        }
    
        const months = [ 
            "January", "February",  
            "March", "April", "May",  
            "June", "July", "August", 
            "September", "October",  
            "November", "December" 
        ]; 

    return (
        <div id="calendarWidget" className = "gradientBG">
            <div id="incomeWidget">
              <div className="incomeWidgetHeader">
                  <div className="monthNav">
                      <button onClick={() => {updateMonth("prev"); console.log(month)}}><ChevronLeft size={16} color="#ffffff" strokeWidth={1} /></button>
                      <h2>{months[month]} {year}</h2>
                      <button onClick={() => updateMonth("next")}><ChevronRight size={16} color="#ffffff" strokeWidth={1} /></button>
                  </div>
                  <BadgeDollarSign color="#ffffff" strokeWidth={0.75} />
                  <div>
                      <p><span className="monthPaid">${monthPaid}</span> / <span className="monthIncome">${monthIncome}</span> / <span className="monthlyTarget">${monthlyTarget}</span></p>
                  </div>
              </div>
              <div className = "progressBar">
                  {/* <div className="paidBar" style={{width: monthPaid > 0 ? (`${(monthPaid/monthIncome)*100}%`): "0%"}}><span>$</span></div> */}
                  {/* <div className="incomeBar" style={{width: monthIncome > 0 ? (`${(1-(monthPaid/monthIncome))*100}%`) : "100%"}}></div> */}
                  {/* <div className="incomeBar" ></div> */}

                  {/* <div className="paidBar" style={{width: monthPaid > 0 ? (`${(monthPaid/monthlyTarget)*100}%`): "0%"}}><span>$</span></div>
                  <div className="incomeBar" style={{width: monthIncome > 0 ? (`${((monthIncome-monthPaid)/monthlyTarget)*100}%`): "0%"}}><span>$</span></div> */}

                  <div className="paidBar" style={{width: monthPaid > 0 ? (`${(monthPaid/monthlyTarget)*100}%`): "0%"}}><span>$</span></div>
                  <div className="incomeBar" style={{width: monthIncome > 0 ? (`${((monthIncome)/monthlyTarget)*100}%`): "0%"}}><span></span></div>

                  {/* <div className="incomeBar" style={{width: monthIncome > 0 ? (`${(1-(monthPaid/monthIncome))*100}%`) : "100%"}}></div> */}
                  {/* <div className="incomeBar" ></div> */}
              </div>
            </div>
        <div id="calSection" className="blackBG">
        {/* //set value depending if selected date has changed */}
        {/* <Calendar value={selectedDate==undefined ? new Date(year, month, thisDay) : selectedDate} compact renderCell={renderCell} onSelect={handleSelect} defaultValue={today} /> */}
            <Calendar compact renderCell={renderCell} onSelect={handleSelect} value={new Date(year, month, thisDay)} defaultValue={today} /> 
            </div>
            <TodoList date={selectedDate} />
            {/* if no active projects... */}
            {/* <Calendar compact /> */}
        </div>
    )

};




export default CalendarWidget;